// Copyright 2025. WebPros International GmbH. All rights reserved.

export const ACTIONS = {
    REMOVE: 'remove',
    BATCH_REMOVE: 'batch-remove',
};

export const SEVER_MIGRATION_STATUS = 'server-migration-status';
